import type { ReactNode } from "react";
import { cn } from "./utils";

interface AdminToolbarProps {
  children: ReactNode;
  actions?: ReactNode;
  className?: string;
}

const AdminToolbar = ({ children, actions, className }: AdminToolbarProps) => {
  return (
    <div className={cn("flex flex-col gap-3 md:flex-row md:items-center md:justify-between", className)}>
      <div className="flex-1 min-w-0">{children}</div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
};

export default AdminToolbar;
